export default function(){
    $(document).ready(function(){
        var activeLabel = $('.js-category-select').find('li.active').last().children('a').text();
        if(activeLabel){
            $('.js-category-select-label').text( activeLabel );
        }
    });
    $('.js-category-select').click(function(){
        $(this).toggleClass('open');
        $(this).find('nav').slideToggle(100);
        if( $(this).find('.js-category-select-label').text() != 'Select Category'){
            $(this).find('.js-category-select-label').text('Select Category');
        }else{
            activeLabel = $(this).find('li.active').last().children('a').text();
            if(activeLabel){
                $(this).children('.js-category-select-label').text( activeLabel );
            }
        }
    });
}
